export interface IOpoTax {
    id: number,
    lineItemType: number,
    description: string,
    taxPercent: number
}

export interface IOpoTaxRequest {
    lineItemType: number,
    taxPercent: number
}

export interface IOpoTaxLineItemType {
    id: number,
    description: string
}

export interface IOpoTaxesData {
    taxes: IOpoTax[],
    lineItemTypes: IOpoTaxLineItemType[]
}
